import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';
import ImageUpload from '@fuww/library/src/ImageUpload';
import { LookbookUploadButton, Privacy, UploadHint }
from '@fuww/library/src/Lookbook/Upload';
import Anchor from '@fuww/library/src/Anchor';
import { AuthProvider } from '../../AuthProvider';
import Authorized from '../Authorized';
import createImageMutation
from '../../../lib/mutations/createImage.graphql';
import processUploadedFiles
from '../../../lib/processUploadedFiles';

const PrivacyPolicy = () => (
  <Privacy>
    <Anchor
      href="/privacy"
      target="_blank"
      styled
    >
      Privacy statement:
    </Anchor>
    {' '}
    {' '}
    FashionUnited values your trust in its services and is committed
    to maintaining that trust and respecting your privacy.
    FashionUnited wants to ensure that the information gathered
    about you will only be used by FashionUnited and will not be
    sold to third parties. You may, at any time, contact
    FashionUnited to view, update, modify or remove
    your personal information from the
    database and restrict our processing of it. For more information
    see the
    {' '}
    {' '}
    <Anchor
      href="/privacy"
      target="_blank"
      styled
    >
      Privacy Policy
    </Anchor>
  </Privacy>
);

const KeywordsHint = () => (
  <UploadHint>
    Keywords are added automatically by
    FashionUnited’s smart system after uploading.
  </UploadHint>
);

const Uploader = ({ refetch }) => {
  const [showModal, setShowModal] = useState(true);
  const [createImage] = useMutation(createImageMutation);

  const handleOnUploadImage = async (
    fileData,
    title,
    description,
    credits,
    setDisabled,
  ) => {
    setDisabled(true);
    setShowModal(false);
    const results = await processUploadedFiles(
      createImage,
      Array.isArray(fileData) ? fileData : [fileData],
      {
        title,
        description,
        credits,
        internalUseOnly: false,
      },
    );
    setDisabled(false);

    if (results.every(({ status }) => status === 'fulfilled')) {
      refetch();
      enqueueSnackbar('Image uploaded successfully');
      setShowModal(true);
      return;
    }
    results.filter(({ status }) => status === 'rejected').forEach(
      ({ reason }) => enqueueSnackbar(reason.message),
    );
  };

  return showModal ? (
    <AuthProvider>
      <Authorized>
        <ImageUpload
          id="lookbook-image-upload"
          onSave={handleOnUploadImage}
          required
          addCredit
          creditRequired={false}
          addMetadata
          hints={(<KeywordsHint />)}
          conditions={(<PrivacyPolicy />)}
          DragAndDropComponent={LookbookUploadButton}
          allowBatchUpload
        />
      </Authorized>
    </AuthProvider>
  ) : null;
};

Uploader.propTypes = {
  refetch: PropTypes.func.isRequired,
};

export default Uploader;
